import { JourneyTrack } from '../journey-track';
import { TrackTypes } from '../model/track-types';
import { TrackInfo } from '../model/track-info';
import { TrackActionResult } from "../model/track-action-result";
import { ContaIonDataParse } from "../conta-ion/util/conta-ion-data-parse";
import { CacheService } from "../../../comunicator-native/cache/v2/cache.service";
import { MaritalStatusInvestAction } from './actions/marital-status-action';

export class BasicMaritalTrack extends JourneyTrack {
  readonly originalTracks = [

    new TrackInfo('marital-status', ['marital-status', 'marital-status'], undefined, {
      undefined,
      actionName: ActionList.ActionMarital
    }),
    new TrackInfo('spouse', ['marital-status', 'spouse']),

  ];

  track = [];

  constructor(private cacheNativeService: CacheService) {
    super();
    this.track = this.originalTracks;
  }


  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.BASIC;
  }

  async loadData() {
    // MobileMockData.executeMockCall(500);
    let data = await this.cacheNativeService.getItemCommunicator();
    data = ContaIonDataParse.parseFromMobileData(data);
    localStorage.setItem('cache-native', JSON.stringify(data));
    return Promise.resolve(data);
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    return MaritalStatusInvestAction.execute(data, this.track);
  }

  isUncoupled() {
    return false;
  }

  isEventComunicator() {
    return true;
  }

  isBackHeader() {
    return false;
  }
}

export enum ActionList {
  ActionMarital = 'actionMarital'
}